// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/agent/v1/agent_template.proto (package chalk.agent.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import { file_chalk_flags_v1_flags } from "../../flags/v1/flags_pb";
import type { NullValue, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/agent/v1/agent_template.proto.
 */
export const file_chalk_agent_v1_agent_template: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_permissions, file_chalk_flags_v1_flags, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * AgentTemplateInput declares one keyed parameter conversations created from
 * the template supply at creation time (CreateConversationRequest
 * .template_inputs). The template's system prompt references an input with the
 * same @-mention token syntax the dashboard uses for other entities —
 * @[name](chalk://input/<name>) — and the runner replaces each token with the
 * supplied value when it formats the system prompt for a turn.
 *
 * @generated from message chalk.agent.v1.AgentTemplateInput
 */
export type AgentTemplateInput = Message<"chalk.agent.v1.AgentTemplateInput"> & {
  /**
   * Key, unique within the template. Restricted to identifier-like names
   * ([A-Za-z_][A-Za-z0-9_-]*) so it can appear in the chalk://input/ token.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * Must be a concrete type (not UNSPECIFIED).
   *
   * @generated from field: chalk.agent.v1.AgentTemplateInputType type = 3;
   */
  type: AgentTemplateInputType;

  /**
   * When true the value may be omitted or explicitly null at conversation
   * creation; otherwise CreateConversation rejects requests that don't supply
   * a value of the declared type.
   *
   * @generated from field: bool nullable = 4;
   */
  nullable: boolean;
};

/**
 * Describes the message chalk.agent.v1.AgentTemplateInput.
 * Use `create(AgentTemplateInputSchema)` to create a new message.
 */
export const AgentTemplateInputSchema: GenMessage<AgentTemplateInput> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_agent_template, 0);

/**
 * AgentTemplateInputValue is one supplied value for a template-declared
 * input. The variant set must match the declared AgentTemplateInputType;
 * null_value is only legal for nullable inputs.
 *
 * @generated from message chalk.agent.v1.AgentTemplateInputValue
 */
export type AgentTemplateInputValue = Message<"chalk.agent.v1.AgentTemplateInputValue"> & {
  /**
   * @generated from oneof chalk.agent.v1.AgentTemplateInputValue.value
   */
  value: {
    /**
     * @generated from field: string string_value = 1;
     */
    value: string;
    case: "stringValue";
  } | {
    /**
     * @generated from field: double float_value = 2;
     */
    value: number;
    case: "floatValue";
  } | {
    /**
     * @generated from field: int64 int_value = 3;
     */
    value: bigint;
    case: "intValue";
  } | {
    /**
     * Explicit null for a nullable input.
     *
     * @generated from field: google.protobuf.NullValue null_value = 4;
     */
    value: NullValue;
    case: "nullValue";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.agent.v1.AgentTemplateInputValue.
 * Use `create(AgentTemplateInputValueSchema)` to create a new message.
 */
export const AgentTemplateInputValueSchema: GenMessage<AgentTemplateInputValue> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_agent_template, 1);

/**
 * AgentTemplate is a reusable agent configuration a conversation can be
 * created from: a system prompt, a preferred model, and the set of tools the
 * agent is allowed to call. Tools are referenced by the chalk-mcp-gateway's
 * stable namespaced identifier ("<backend>__<tool>"); the runner discovers
 * them via the gateway's ListBackends and dispatches calls through the
 * gateway's CallTool. Entries without the "__" separator refer to the
 * server's built-in MCP tools by bare name (e.g. "execute_sql_query").
 *
 * @generated from message chalk.agent.v1.AgentTemplate
 */
export type AgentTemplate = Message<"chalk.agent.v1.AgentTemplate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * Human-readable label, unique within an environment. Used by the UI and
   * as the lookup handle.
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * Prepended as the system message on every runner iteration. When the
   * conversation also carries notebook context, the notebook guidance is
   * appended after this prompt.
   *
   * @generated from field: string system_prompt = 5;
   */
  systemPrompt: string;

  /**
   * Preferred model id (e.g. "gpt-4o-mini"). Precedence at RunTurn time:
   * RunTurnRequest.model > AgentConversation.model_name > this > connection
   * default > provider default.
   *
   * @generated from field: string model_name = 6;
   */
  modelName: string;

  /**
   * Optional AiProviderConnection to run this template's conversations
   * against. Used when the conversation itself does not pin a connection.
   *
   * @generated from field: string ai_provider_connection_id = 7;
   */
  aiProviderConnectionId: string;

  /**
   * The exact allowlist of tools conversations created from this template may
   * use. "<backend>__<tool>" entries are chalk-mcp-gateway tools; bare names
   * are built-in MCP tools. An empty list means the agent runs pure-chat with
   * no tools (conversations WITHOUT a template keep the default behavior of
   * every built-in tool).
   *
   * @generated from field: repeated string allowed_tools = 8;
   */
  allowedTools: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * Datasources (integrations) the agent may query, by integration name
   * (Integration.id for unnamed integrations). Unlike allowed_tools, an EMPTY
   * list means unrestricted — restriction is opt-in. Advisory today: stored
   * and surfaced in the dashboard, but not yet enforced by the runner's
   * query/SQL tools.
   *
   * @generated from field: repeated string allowed_datasources = 11;
   */
  allowedDatasources: string[];

  /**
   * @generated from field: chalk.agent.v1.AgentTemplateKind kind = 12;
   */
  kind: AgentTemplateKind;

  /**
   * Keyed parameters conversations created from this template supply at
   * creation. Order is the display order in the dashboard.
   *
   * @generated from field: repeated chalk.agent.v1.AgentTemplateInput inputs = 13;
   */
  inputs: AgentTemplateInput[];
};

/**
 * Describes the message chalk.agent.v1.AgentTemplate.
 * Use `create(AgentTemplateSchema)` to create a new message.
 */
export const AgentTemplateSchema: GenMessage<AgentTemplate> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_agent_template, 2);

/**
 * @generated from message chalk.agent.v1.CreateAgentTemplateRequest
 */
export type CreateAgentTemplateRequest = Message<"chalk.agent.v1.CreateAgentTemplateRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string system_prompt = 3;
   */
  systemPrompt: string;

  /**
   * @generated from field: string model_name = 4;
   */
  modelName: string;

  /**
   * @generated from field: string ai_provider_connection_id = 5;
   */
  aiProviderConnectionId: string;

  /**
   * @generated from field: repeated string allowed_tools = 6;
   */
  allowedTools: string[];

  /**
   * @generated from field: repeated string allowed_datasources = 7;
   */
  allowedDatasources: string[];

  /**
   * UNSPECIFIED creates a GENERAL template.
   *
   * @generated from field: chalk.agent.v1.AgentTemplateKind kind = 8;
   */
  kind: AgentTemplateKind;

  /**
   * @generated from field: repeated chalk.agent.v1.AgentTemplateInput inputs = 9;
   */
  inputs: AgentTemplateInput[];
};

/**
 * Describes the message chalk.agent.v1.CreateAgentTemplateRequest.
 * Use `create(CreateAgentTemplateRequestSchema)` to create a new message.
 */
export const CreateAgentTemplateRequestSchema: GenMessage<CreateAgentTemplateRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_agent_template, 3);

/**
 * @generated from message chalk.agent.v1.CreateAgentTemplateResponse
 */
export type CreateAgentTemplateResponse = Message<"chalk.agent.v1.CreateAgentTemplateResponse"> & {
  /**
   * @generated from field: chalk.agent.v1.AgentTemplate template = 1;
   */
  template?: AgentTemplate;
};

/**
 * Describes the message chalk.agent.v1.CreateAgentTemplateResponse.
 * Use `create(CreateAgentTemplateResponseSchema)` to create a new message.
 */
export const CreateAgentTemplateResponseSchema: GenMessage<CreateAgentTemplateResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_agent_template, 4);

/**
 * @generated from message chalk.agent.v1.GetAgentTemplateRequest
 */
export type GetAgentTemplateRequest = Message<"chalk.agent.v1.GetAgentTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.agent.v1.GetAgentTemplateRequest.
 * Use `create(GetAgentTemplateRequestSchema)` to create a new message.
 */
export const GetAgentTemplateRequestSchema: GenMessage<GetAgentTemplateRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_agent_template, 5);

/**
 * @generated from message chalk.agent.v1.GetAgentTemplateResponse
 */
export type GetAgentTemplateResponse = Message<"chalk.agent.v1.GetAgentTemplateResponse"> & {
  /**
   * @generated from field: chalk.agent.v1.AgentTemplate template = 1;
   */
  template?: AgentTemplate;
};

/**
 * Describes the message chalk.agent.v1.GetAgentTemplateResponse.
 * Use `create(GetAgentTemplateResponseSchema)` to create a new message.
 */
export const GetAgentTemplateResponseSchema: GenMessage<GetAgentTemplateResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_agent_template, 6);

/**
 * @generated from message chalk.agent.v1.ListAgentTemplatesRequest
 */
export type ListAgentTemplatesRequest = Message<"chalk.agent.v1.ListAgentTemplatesRequest"> & {
};

/**
 * Describes the message chalk.agent.v1.ListAgentTemplatesRequest.
 * Use `create(ListAgentTemplatesRequestSchema)` to create a new message.
 */
export const ListAgentTemplatesRequestSchema: GenMessage<ListAgentTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_agent_template, 7);

/**
 * @generated from message chalk.agent.v1.ListAgentTemplatesResponse
 */
export type ListAgentTemplatesResponse = Message<"chalk.agent.v1.ListAgentTemplatesResponse"> & {
  /**
   * @generated from field: repeated chalk.agent.v1.AgentTemplate templates = 1;
   */
  templates: AgentTemplate[];
};

/**
 * Describes the message chalk.agent.v1.ListAgentTemplatesResponse.
 * Use `create(ListAgentTemplatesResponseSchema)` to create a new message.
 */
export const ListAgentTemplatesResponseSchema: GenMessage<ListAgentTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_agent_template, 8);

/**
 * @generated from message chalk.agent.v1.UpdateAgentTemplateRequest
 */
export type UpdateAgentTemplateRequest = Message<"chalk.agent.v1.UpdateAgentTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Scalar fields are only applied when non-empty; pass an empty string to
   * leave the field unchanged.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string system_prompt = 4;
   */
  systemPrompt: string;

  /**
   * @generated from field: string model_name = 5;
   */
  modelName: string;

  /**
   * @generated from field: string ai_provider_connection_id = 6;
   */
  aiProviderConnectionId: string;

  /**
   * allowed_tools is only applied when has_allowed_tools is true, so a
   * template can be updated to an explicitly-empty (no tools) allowlist.
   *
   * @generated from field: repeated string allowed_tools = 7;
   */
  allowedTools: string[];

  /**
   * @generated from field: bool has_allowed_tools = 8;
   */
  hasAllowedTools: boolean;

  /**
   * allowed_datasources is only applied when has_allowed_datasources is true,
   * so a template can be updated back to the empty (unrestricted) list.
   *
   * @generated from field: repeated string allowed_datasources = 9;
   */
  allowedDatasources: string[];

  /**
   * @generated from field: bool has_allowed_datasources = 10;
   */
  hasAllowedDatasources: boolean;

  /**
   * Like the scalar fields, only applied when not UNSPECIFIED; pass GENERAL
   * to switch a notebook agent back.
   *
   * @generated from field: chalk.agent.v1.AgentTemplateKind kind = 11;
   */
  kind: AgentTemplateKind;

  /**
   * inputs is only applied when has_inputs is true, so a template can be
   * updated to an explicitly-empty input list.
   *
   * @generated from field: repeated chalk.agent.v1.AgentTemplateInput inputs = 12;
   */
  inputs: AgentTemplateInput[];

  /**
   * @generated from field: bool has_inputs = 13;
   */
  hasInputs: boolean;
};

/**
 * Describes the message chalk.agent.v1.UpdateAgentTemplateRequest.
 * Use `create(UpdateAgentTemplateRequestSchema)` to create a new message.
 */
export const UpdateAgentTemplateRequestSchema: GenMessage<UpdateAgentTemplateRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_agent_template, 9);

/**
 * @generated from message chalk.agent.v1.UpdateAgentTemplateResponse
 */
export type UpdateAgentTemplateResponse = Message<"chalk.agent.v1.UpdateAgentTemplateResponse"> & {
  /**
   * @generated from field: chalk.agent.v1.AgentTemplate template = 1;
   */
  template?: AgentTemplate;
};

/**
 * Describes the message chalk.agent.v1.UpdateAgentTemplateResponse.
 * Use `create(UpdateAgentTemplateResponseSchema)` to create a new message.
 */
export const UpdateAgentTemplateResponseSchema: GenMessage<UpdateAgentTemplateResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_agent_template, 10);

/**
 * @generated from message chalk.agent.v1.DeleteAgentTemplateRequest
 */
export type DeleteAgentTemplateRequest = Message<"chalk.agent.v1.DeleteAgentTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.agent.v1.DeleteAgentTemplateRequest.
 * Use `create(DeleteAgentTemplateRequestSchema)` to create a new message.
 */
export const DeleteAgentTemplateRequestSchema: GenMessage<DeleteAgentTemplateRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_agent_template, 11);

/**
 * @generated from message chalk.agent.v1.DeleteAgentTemplateResponse
 */
export type DeleteAgentTemplateResponse = Message<"chalk.agent.v1.DeleteAgentTemplateResponse"> & {
};

/**
 * Describes the message chalk.agent.v1.DeleteAgentTemplateResponse.
 * Use `create(DeleteAgentTemplateResponseSchema)` to create a new message.
 */
export const DeleteAgentTemplateResponseSchema: GenMessage<DeleteAgentTemplateResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_agent_template, 12);

/**
 * The surface conversations created from a template open in. GENERAL agents
 * run as plain conversations; NOTEBOOK agents get a notebook created and
 * attached at conversation start, so their tools default to that notebook and
 * the UI opens on the notebook page. UNSPECIFIED reads as GENERAL, keeping
 * rows written before this field existed valid.
 *
 * @generated from enum chalk.agent.v1.AgentTemplateKind
 */
export enum AgentTemplateKind {
  /**
   * @generated from enum value: AGENT_TEMPLATE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_TEMPLATE_KIND_GENERAL = 1;
   */
  GENERAL = 1,

  /**
   * @generated from enum value: AGENT_TEMPLATE_KIND_NOTEBOOK = 2;
   */
  NOTEBOOK = 2,
}

/**
 * Describes the enum chalk.agent.v1.AgentTemplateKind.
 */
export const AgentTemplateKindSchema: GenEnum<AgentTemplateKind> = /*@__PURE__*/
  enumDesc(file_chalk_agent_v1_agent_template, 0);

/**
 * The value type an agent template input accepts.
 *
 * @generated from enum chalk.agent.v1.AgentTemplateInputType
 */
export enum AgentTemplateInputType {
  /**
   * @generated from enum value: AGENT_TEMPLATE_INPUT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_TEMPLATE_INPUT_TYPE_STRING = 1;
   */
  STRING = 1,

  /**
   * @generated from enum value: AGENT_TEMPLATE_INPUT_TYPE_FLOAT = 2;
   */
  FLOAT = 2,

  /**
   * @generated from enum value: AGENT_TEMPLATE_INPUT_TYPE_INT = 3;
   */
  INT = 3,
}

/**
 * Describes the enum chalk.agent.v1.AgentTemplateInputType.
 */
export const AgentTemplateInputTypeSchema: GenEnum<AgentTemplateInputType> = /*@__PURE__*/
  enumDesc(file_chalk_agent_v1_agent_template, 1);

/**
 * @generated from service chalk.agent.v1.AgentTemplateService
 */
export const AgentTemplateService: GenService<{
  /**
   * @generated from rpc chalk.agent.v1.AgentTemplateService.CreateAgentTemplate
   */
  createAgentTemplate: {
    methodKind: "unary";
    input: typeof CreateAgentTemplateRequestSchema;
    output: typeof CreateAgentTemplateResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentTemplateService.GetAgentTemplate
   */
  getAgentTemplate: {
    methodKind: "unary";
    input: typeof GetAgentTemplateRequestSchema;
    output: typeof GetAgentTemplateResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentTemplateService.ListAgentTemplates
   */
  listAgentTemplates: {
    methodKind: "unary";
    input: typeof ListAgentTemplatesRequestSchema;
    output: typeof ListAgentTemplatesResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentTemplateService.UpdateAgentTemplate
   */
  updateAgentTemplate: {
    methodKind: "unary";
    input: typeof UpdateAgentTemplateRequestSchema;
    output: typeof UpdateAgentTemplateResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentTemplateService.DeleteAgentTemplate
   */
  deleteAgentTemplate: {
    methodKind: "unary";
    input: typeof DeleteAgentTemplateRequestSchema;
    output: typeof DeleteAgentTemplateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_agent_v1_agent_template, 0);

